import React, { useState } from "react";
import { Link } from "react-router-dom";
import icoMapa from "../../assets/img/ico-mapa.svg";
import MenuButton from "../../components/Partials/MenuButton";
import { translate } from "../../assets/js/functions";

const Menu = ({ periods }) => {
  const [hidden, setHidden] = useState(true);
  const toggleVisibility = () => {
    setHidden(!hidden);
  };

  const handleMapLinkClick = () => {
    setHidden(true);
  };

  return (
  <>
  {periods?
  <nav className="main-nav" aria-label="Menú principal" id="main-nav">
    <MenuButton onClick={toggleVisibility} isOpen={!hidden} />
    <div
      className="has-background-white has-text-weight-bold is-relative"
      id="menu"
      hidden={hidden}
    >
      <ol className="flow--2xl">
        {periods.map((period) => (
          <li key={period.term_id}>
            {period && (
              <>
                <Link key={period.term_id} onClick={() => setHidden(true)}  to={"/exposition#" + period.term_id}>{period.term}</Link>
                {period.childrens ?
                <ol className="is-size-3 is-flex is-flex-wrap-wrap gap-3 is-family-secondary mt-5">

                    {period.childrens.map((res) =>
                      <Link key={res.term_id} onClick={() => setHidden(true)} to={"/exposition#" + res.term_id}>
                        {res.term}
                      </Link>
                    )}
                </ol>
                :''}
              </>
            )}
          </li>
        ))}
      </ol>
      <Link
        to={"/map"}
        className="btn-map is-flex is-flex-direction-column is-align-items-center is-justify-content-center p-5 has-text-centered ml-auto mr-auto link-dn"
        onClick={handleMapLinkClick}
      >
        <img
          loading="lazy"
          src={icoMapa}
          width="34"
          height="34"
          className="is-block mb-3"
          alt=""
        />
         {translate("Mapa del Censo de Simbología Franquista Retirada")}
      </Link>
    </div>
  </nav>
  :''}
  </>
  );
};

export default Menu;
